import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";

export default function PrivacyPolicy() {
  const [content, setContent] = useState("");

  useEffect(() => {
    loadDoc();
  }, []);

  const loadDoc = async () => {
    try {
      const res = await axios.get(`${API}/admin/terms/active?type=privacy_policy`);
      setContent(res.data?.content || "Política de Privacidade não disponível.");
    } catch (e) {
      setContent("Erro ao carregar Política de Privacidade.");
    }
  };

  return (
    <div
      data-testid="privacy-policy-page"
      style={{ maxWidth: 800, margin: "40px auto", padding: 20 }}
    >
      <h1>Política de Privacidade</h1>
      <div style={{ whiteSpace: "pre-wrap" }}>{content}</div>
    </div>
  );
}
